import { useTranslation } from 'react-i18next';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@monksflow/monks-ui';
import { TagInput } from '@/shared/ui/TagInput';

export interface SelectFieldValue {
  selected: string[];
}

export interface SelectFieldConfig {
  options?: string[];
  multiple?: boolean;
}

interface SelectFieldProps {
  value: SelectFieldValue | null;
  config: SelectFieldConfig;
  disabled?: boolean;
  onChange: (next: SelectFieldValue) => void;
}

/**
 * Pure, controlled. `config.multiple` picks the control: a single-choice dropdown (replaces
 * the selection) or a chip-based multi-select (appends/removes), both driven by the same
 * `config.options` list.
 */
export function SelectField({ value, config, disabled = false, onChange }: SelectFieldProps) {
  const { t } = useTranslation('projects');
  const options = config.options ?? [];
  const selected = value?.selected ?? [];

  return (
    <div className="flex flex-col gap-2">
      {config.multiple ? (
        <TagInput
          value={selected}
          onChange={(next) => onChange({ selected: next })}
          options={options}
          disabled={disabled}
        >
          <TagInput.Chips
            placeholder={t('projectBriefDetail.briefSectionField.selectField.placeholder')}
          />
          <TagInput.Content />
        </TagInput>
      ) : (
        <Select
          value={selected[0] ?? ''}
          disabled={disabled}
          onValueChange={(next: string) => onChange({ selected: next ? [next] : [] })}
        >
          <SelectTrigger>
            <SelectValue
              placeholder={t('projectBriefDetail.briefSectionField.selectField.placeholder')}
            />
          </SelectTrigger>
          <SelectContent>
            {options.map((option) => (
              <SelectItem key={option} value={option}>
                {option}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    </div>
  );
}
